// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-description-description-brgkv p:not(:last-child){margin-bottom:16px}.components-products-description-description-brgkv.components-products-description-mobile-bttxl p{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "components-products-description-description-brgkv",
	"mobile": "components-products-description-mobile-bttxl"
};
module.exports = ___CSS_LOADER_EXPORT___;
